<template>
  <div class="section section-gallery">
    <b-container>
      <h1 id="comunity">Comunitate</h1>
      <img src="./../assets/mustata-only.png" alt class="logo-mustata" />

      <b-row align-h="center">
        <b-col cols="10">
          <p>Mustața de Bere este sufletul unei comunități care pornește de la echipa care creează berea artizanală - Rareș Petre, Csillag Janos, Maria Elena Montero Gonzalez - și include susținătorii care duc povestea mai departe, partenerii care promovează acest brand și prietenii care o consumă.</p>
        </b-col>
      </b-row>

      <h1 class="hashtag mt-4">#mustatacalatoare</h1>
    </b-container>
    <div class="d-none d-md-block d-lg-block">
      <VueSlickCarousel v-bind="settingsBig">
        <img src="./../assets/locations/houston.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/petra.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/usa.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/australia.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/italy.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/cambodia.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/maroc.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/uae.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/pedrum.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/ocean.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/concorde.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/paris-1.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/grecia.jpg" alt class="gallery-slide" />
      </VueSlickCarousel>
    </div>

    <div class="d-none d-block d-sm-block d-md-none">
      <VueSlickCarousel v-bind="settingsSmall">
        <img src="./../assets/locations/houston.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/petra.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/usa.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/australia.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/italy.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/cambodia.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/maroc.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/uae.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/pedrum.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/ocean.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/concorde.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/paris-1.jpg" alt class="gallery-slide" />
        <img src="./../assets/locations/grecia.jpg" alt class="gallery-slide" />
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "Gallery",
  components: { VueSlickCarousel },

  data() {
    return {
      settingsSmall: {
        arrows: false,
        dots: true,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        touchThreshold: 5,
        autoplay: true
      },

      settingsBig: {
        arrows: false,
        dots: true,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 2,
        touchThreshold: 5,
        autoplay: true
      }
    };
  }
};
</script>

<style>
.gallery-slide {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

span#comunity {
  margin-top: -200px;
}
</style>